module.exports = __webpack_public_path__ + "718d0daab66ba652f239c600b713a2e7.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/ss-glyphish-filled.woff
// module id = 349
// module chunks = 0